import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77bef46e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "content-container",
  style: {"justify-content":"flex-start","padding-top":"1rem"}
}
const _hoisted_2 = {
  key: 0,
  class: "loading"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "loader" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  style: {"display":"contents"}
}
const _hoisted_6 = { class: "top-content" }
const _hoisted_7 = { class: "flex-col-centered date-picker selection" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "vat-return-date" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "header" }, "Drawdown Date:")
], -1))
const _hoisted_9 = { class: "flex-col-centered selection" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "drawdown-amount" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "header" }, "Drawdown Amount:")
], -1))

import { inject, ref } from "vue";
import MarketSelector from "@/components/MarketSelector.vue";
import { dateFormat, marketSelection } from "@/services/helpers/Helper";
import DatePicker from "@/components/common/DatePicker.vue";
import CurrencyInput from "@/components/CurrencyInput.vue";
import { globalReloadKey } from "@/types/ServiceKeys";
import DrawdownPopUp from "@/components/VATLoan/DrawdownPopUp.vue";
import { DrawdownTableItem } from "@/models/Drawdown";

const submitHint = "Submit the payment form";

export default /*#__PURE__*/_defineComponent({
  __name: 'SubmitDrawdown',
  setup(__props) {

const isLoading = ref(false);
const drawdownDate = ref<Date | undefined>();
const drawdownAmount = ref<string | undefined>();
const payment = ref<Partial<DrawdownTableItem>>({ Market: marketSelection.value });
const showPopUp = ref<boolean>(false);
const reload = inject(globalReloadKey);

async function submit() {
    payment.value = {
        Market: marketSelection.value,
        DrawdownDate: drawdownDate.value!,
        DrawdownAmount: parseFloat(drawdownAmount.value!),
    };

    showPopUp.value = true;
}
function refreshAfterConfirm() {
    showPopUp.value = false;
    reload?.();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("form", {
              class: "form-container flex-row-centered",
              onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (submit()), ["prevent"]))
            }, [
              _createVNode(MarketSelector),
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createVNode(DatePicker, {
                  id: "drawdown-date",
                  modelValue: drawdownDate.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((drawdownDate).value = $event)),
                  type: "date",
                  placeholder: "Select Date...",
                  format: _unref(dateFormat),
                  "enable-time-picker": false,
                  textInput: "",
                  "prevent-min-max-navigation": "",
                  teleport: true,
                  required: "",
                  maxDate: new Date()
                }, null, 8, ["modelValue", "format", "maxDate"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(CurrencyInput, {
                  id: "drawdown-amount",
                  modelValue: drawdownAmount.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((drawdownAmount).value = $event)),
                  min: 0.01,
                  title: "The drawdown amount",
                  required: ""
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("button", {
                type: "submit",
                class: "default-btn",
                title: submitHint
              }, " Confirm ")
            ], 32)
          ])
        ])),
    (showPopUp.value)
      ? (_openBlock(), _createBlock(DrawdownPopUp, {
          key: 2,
          modelValue: payment.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((payment).value = $event)),
          onConfirm: refreshAfterConfirm
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}
}

})